export default "__VITE_ASSET__DvwGuIfX__"